function buildInputValidationConfigs(errorMessages) {
    return [
        {
            hasToBeChecked: (input) => !!input.required,
            check: (input) => !!input.value,
            message: errorMessages.required,
        },
        {
            hasToBeChecked: (input) => input.getAttribute('type') === 'email',
            check: (input) => /.+@.+\..+/.test(input.value),
            message: errorMessages.email,
        },
    ];
}

function buildListValidationConfigs(errorMessages) {
    return [
        {
            hasToBeChecked: (inputs) => !inputs.filter((input) => !input.required).length,
            check: (inputs) => !!inputs.find((input) => input.checked),
            message: errorMessages.required,
        },
    ];
}

export class InputValidatorService {
    constructor({errorMessages = {}} = {errorMessages: {}}) {
        this.errorMessages = errorMessages;
        this.inputValidationConfigs = buildInputValidationConfigs(this.errorMessages);
        this.listValidationConfigs = buildListValidationConfigs(this.errorMessages);
    }

    validateInputWithConfigs(input, configs) {
        const failedCheck = configs.find((conf) => {
            return conf.hasToBeChecked(input) && !conf.check(input);
        });

        if (failedCheck) {
            return {
                valid: false,
                errorMessage: failedCheck.message,
            };
        }

        return {
            valid: true,
            errorMessage: null,
        };
    }

    validateInput(input) {
        return this.validateInputWithConfigs(input, this.inputValidationConfigs);
    }

    validateList(list) {
        const inputs = Array.from(list.querySelectorAll('input'));
        return this.validateInputWithConfigs(inputs, this.listValidationConfigs);
    }
}
